module.exports = __webpack_public_path__ + "static/media/logo-dark.64108ccf.svg";